import BdcImport from "../components/Bdc/Import";

const BdcImportPage = () => <BdcImport />;

export default BdcImportPage;
